
<script setup lang="ts">
const excerpt = undefined
  defineExpose({ frontmatter: {}, excerpt: undefined })
</script>
<script lang="ts">
/** frontmatter meta-data for MD page **/
export interface Frontmatter {
  title?: string
  description?: string
  subject?: string
  category?: string
  name?: string
  excerpt?: string
  image?: string
  layout?: string
  requiredAuth?: boolean
  meta?: Record<string, any>[]
  [key: string]: unknown
}
export const frontmatter: Frontmatter = {}
export const excerpt: string | undefined = ""

</script>
<template>
<div class="markdown-body"><h1>隐私政策</h1>
<h3>北京饼次元科技有限公司（以下简称“我们”或“本应用”）作为饼次元（以下简称“应用”）的开发者和运营者，尊重并保护所有使用服务用户的个人隐私权。为了给您提供更好的服务，本应用会按照本隐私权政策的规定使用和披露您的个人信息。但本应用将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本应用不会将这些信息对外披露或向第三方提供。本应用会不时更新本隐私权政策。 您在同意本应用服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于本应用服务使用协议不可分割的一部分。 特别声明：本隐私政策适用于名下所有的应用。</h3>
<h3>1. 我们收集的信息及使用的SDK</h3>
<p>为保障本应用相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方提供的软件开发包（SDK）实现相关目的。 我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。 我们对接入的相关第三方SDK在目录中列明。 请注意，第三方SDK可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，请以其公示的官方说明为准；</p>
<p>穿山甲SDK com.bytedance.sdk.openadsdk<br>
使用目的：广告投放<br>
<strong>数据类型：加速度传感器；剪切板；设备标识信息，设备序列号，包括但不限于IMEI/设备ID(DEVICE_ID)/IDFA/OAID/设备MAC地址或其他永久性或非永久性设备标识符（“设备标识符”）</strong><br>
官网链接： <a href="https://www.pangle.cn/privacy/partner">https://www.pangle.cn/privacy/partner</a></p>
<p>个推SDK com.getui<br>
使用目的：推送社区消息
<strong>数据类型：设备平台、设备厂商、设备品牌、设备型号及系统版本、OAID、AndroidID、WIFI连接信息、运营商信息、DHCP、SSID、BSSID</strong><br>
官网链接： <a href="https://www.getui.com/privacy">https://www.getui.com/privacy</a></p>
<p>微信支付SDK com.tencent.mm.opensdk
使用目的：微信支付功能<br>
<strong>数据类型：设备标识信息，设备序列号，包括但不限于IMEI/设备ID(DEVICE_ID)/IDFA/OAID/设备MAC地址或其他永久性或非永久性设备标识符（“设备标识符”）</strong><br>
官网链接： <a href="https://pay.wechatpay.cn/xdc/weardeviceagreementweb/html/agreement/tenpay_user_privacy">https://pay.wechatpay.cn/xdc/weardeviceagreementweb/html/agreement/tenpay_user_privacy</a></p>
<p>支付宝SDK com.alipay.sdk<br>
使用目的：支付宝支付功能
<strong>数据类型：设备标识信息，设备序列号，包括但不限于IMEI/设备ID(DEVICE_ID)/IDFA/OAID/设备MAC地址或其他永久性或非永久性设备标识符（“设备标识符”）</strong><br>
官网链接： <a href="https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000132">https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000132</a></p>
<h3>2. 权限申请及应用场景、范围</h3>
<p>我们对于软件需要在用户使用的设备上获取的权限非常严格和克制，在使用本应用过程中，我们会向您申请使用该功能所必须的权限，如您不同意开启该权限，请点击“不允许”，拒绝该权限的申请仅将影响您对特定产品功能的使用。我们在此向您列举产品将可能申请的权限及其使用目的；<br>
<strong>网络连接：在获取服务器后台接口数据、上传数据到后台服务器时需要访问网络，过程中可能会产生GPRS流量</strong>；<br>
<strong>电话权限：读取手机状态，获取用户的设备ID/DEVICE_ID，涉及到用户设置的IMEI信息，用于保障您的账号、网络、运营及系统安全，预防钓鱼网站欺诈木马病毒，以及进行数据统计(安装、活跃度等)；</strong><br>
<strong>存储权限：读取、写入手机内部、外部，存储将应用的图片及其他文件缓存/存储到手机上，以及读取已存储的图片及其他文件；</strong><br>
<strong>地理位置权限：接收卫星定位信息，用于广告SDK广告展示，根据位置匹配相应的广告；</strong><br>
<strong>摄像头权限/拍照权限/相机权限：包含拍照功能、视频日记功能、尺子、量角器功能的应用会使用摄像头权限，以便实现应用具体功能，数据均保存在客户端本地；</strong><br>
<strong>定位权限：使用网络进行定位，通过GPS或wifi等方式持续收集您的位置信息，所收集的信息或将用于为您和您的好友相关位置服务；</strong><br>
<strong>录音权限：包含噪音检测、语音日记类型的应用会通过手机或者耳机的麦克使用录音权限，是为了功能实现需要，录制的音频均保存在本地；</strong><br>
<strong>获取通讯录权限：包含文件传输功能的应用需要获取通讯录权限，获取该权限仅为实现文件传输功能需要（便捷地将一台设备的通讯录数据导入到另外一台设备），我们不会上传任何通讯录相关数据到服务器；</strong><br>
<strong>获取软件列表：包含应用隐藏类型的应用会收集软件列表，仅为功能需要，不会上传任何数据；广告投放会收集您的软件列表，以便提供更优质的广告服务；</strong><br>
<strong>陀螺仪传感器: 使用陀螺仪获取个人信息，以便更好地进行广告投放;</strong></p>
<h3>3. 适用范围</h3>
<p>a) 在您注册本应用帐号时，您根据本应用要求提供的个人注册信息；<br>
b) 在您使用本应用网络服务，或访问本应用平台网页时，本应用自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；<br>
c) 本应用通过合法途径从商业伙伴处取得的用户个人数据；<br>
您了解并同意，以下信息不适用本隐私权政策：<br>
a) 您在使用本应用平台提供的搜索服务时输入的关键字信息；<br>
b) 本应用收集到的您在本应用发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情；<br>
c) 违反法律规定或违反本应用规则行为及本应用已对您采取的措施；</p>
<h3>4. 信息使用</h3>
<p>a) 本应用不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和本应用（含本应用关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料；<br>
b) 本应用亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本应用平台用户如从事上述活动，一经发现，本应用有权立即终止与该用户的服务协议；</p>
<h3>5. 信息存储和交换</h3>
<p>a) 我们依照法律法规的规定，将在境内运营过程中产生的你的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循法律法规的规定，征求你的明示同意；</p>
<h3>6. 信息披露</h3>
<p>在如下情况下，本应用将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：<br>
a) 经您事先同意，向第三方披露；<br>
b) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；<br>
c) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；<br>
d) 如您出现违反中国有关法律、法规或者本应用服务协议或相关规则的情况，需要向第三方披露；<br>
e) 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；<br>
f) 在本应用平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，本应用有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决<br>
g) 其它本应用根据法律、法规或者网站政策认为合适的披露；</p>
<h3>7. 业务功能</h3>
<p>登录功能：<br>
a) 授权登录；将通过微信或者QQ授权，获取您的个人信息（包括名称，头像，唯一识别码），实现本APP的登录功能。<br>
b) 账号手机登录；通过您的手机号作为唯一识别码，实现本APP的登录功能。<br>
c) 用户注销；您注销账户之后，我们将实时注销您的账号，并依据您的要求，删除您的个人数据。账号注销路径：我的-&gt;个人信息-&gt;注销账号</p>
<h3>8. 隐私权政策的更新</h3>
<p>a) 如果决定更改隐私政策，我们会在本政策中、本应用网站中以及我们认为适当的位置发布这些更改，以便您了解我们如何收集、使用您的个人信息，哪些人可以访问这些信息，以及在什么情况下我们会透露这些信息；<br>
b) 本应用保留随时修改本政策的权利，因此请经常查看。如对本政策作出重大更改，本应用会通过网站通知的形式告知；<br>
请勿向第三方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是本应用用户名及密码发生泄露，请您立即联络本应用客服，以便本应用采取相应措施；<br>
为了统计分析等目的，我们的产品可能会集成第三方的SDK或其他类似的应用程序，例如友盟+SDK，友盟+SDK需要收集您设备的国际移动设备识别码（IMEI）、iOS广告标识符（IDFA）、设备Mac地址和设备型号等信息；<br>
为了您的信息安全，我们已与第三方SDK服务商约定严格的数据安全保密义务，这些公司会严格遵守我们的数据隐私和安全要求。除非得到您的同意，我们不会与其共享您的个人信息；<br>
为便于您更好地了解友盟+采集的数据类型及用途，以及何保护您的个人信息，您可以访问 <a href="https://www.umeng.com/policy">https://www.umeng.com/policy</a> 了解友盟+隐私权政策；<br>
我们理解并尊重您的选择权，如果您不愿参与友盟+大数据计算，您也可以访问 <a href="https://outdip.umeng.com/opt_out.html">https://outdip.umeng.com/opt_out.html</a> 行使opt-out权利；<br>
我们可能适时修订本《隐私政策》的条款，该等修订构成本《隐私政策》的一部分；<br>
如该等修订造成您在本《隐私政策》下权利的实质减少，我们将在修订生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您；<br>
在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本《隐私政策》的约束；<br>
<strong>联系方式：max@bingciyuan.com</strong><br>
<strong>该隐私政策生效时间：2025年3月1日</strong><br>
<strong>该隐私政策更新时间：2025年3月6日</strong></p>
</div>
</template>
